module.exports = __webpack_public_path__ + "media/images/athletes/1659-3ecb7d334a0c66a61f6db28c4f512956.png";